import Http from './http';

const prefix = '/translate';

var softCache = [];

export const getLanguage = (language = 'en_US', category = '') => {
  return Http.api().get(`${prefix}/language/${language}/${category}`);
};

export const getLanguages = () => {
  if (!softCache['get-languages'])
    softCache['get-languages'] = Http.api().get(`${prefix}/all/languages`);

  return softCache['get-languages'];
};

export const getTranslateCheetah = lang => {
  return Http.authApi().get(`${prefix}/translations/responsive/${lang}`);
};



// WEBPACK FOOTER //
// ./src/js/services/translate.js